import { ScrollView, View, Text } from "react-native";
import FAQData from "@shared/constants/FAQData";
import { MainLayout } from "@shared/components/md-design-system/Layout/MainLayout";
import { useNavigation } from "@react-navigation/native";
export const Faq = () => {
  const navigation = useNavigation();
  const handleGoBack = () => {
    navigation.goBack();
  };
  return (
    <MainLayout navigation={handleGoBack}>
      <ScrollView className="flex-1 px-8 ">
        {FAQData.map((item, index) => (
          <View key={index} className="py-4">
            <Text className="text-base font-semibold mb-2">
              {item.question}
            </Text>
            <Text className="text-sm text-gray-700">{item.answer}</Text>
            {index !== FAQData.length - 1 && (
              <View className="h-px bg-gray-200 mt-4" />
            )}
          </View>
        ))}
      </ScrollView>
    </MainLayout>
  );
};
